<section id="destinations" class="w-full pb-15">
    <!-- Header -->
    @if(view.site?.id != 79) {
    <app-banner_section-type01 [options]="{ title: '', imageHref: this.view.imageLayer1 }"></app-banner_section-type01>
    }
    @if(view.site?.id === 79) {
    @if(view.page) {
    <!-- Header image with smooth flowing bottom -->
    <div class="relative w-screen h-[600px] overflow-hidden">
        <!-- Layer 1 -->
        <img [src]="view.imageLayer1" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 1" [class.opacity-100]="view.activeLayer === 1" />

        <!-- Layer 2 -->
        <img [src]="view.imageLayer2" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 2" [class.opacity-100]="view.activeLayer === 2" />

        <!-- Flowing wave SVG cut -->
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none" class="absolute bottom-0 left-0 w-full h-[80px] block">
            <path d="M0,0 C360,100 1080,0 1440,80 L1440,100 L0,100 Z" fill="white" />
        </svg>
    </div>
    }
    }

    <!-- Package Short info and Meta Tags -->
    <!--   
    <div class="pt-6 px-4">
        <form class="flex items-center max-w-sm mx-auto">   
            <label for="simple-search" class="sr-only">Search</label>
            <div class="relative w-full">
                <input type="text"  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-accent-500 block w-full ps-10 p-2.5  " placeholder="Search packages..." (input)="onSearchQueryChange($event)"/>
            </div>
        </form>
    </div> -->
    <!-- Loading State -->
    @if (view.isLoading) {
    <div class="flex justify-center items-center py-20">
        <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
    </div>
    }
    <!-- Error State -->
    @else if (view.isError) {
    <div class="flex flex-col justify-center items-center py-20 text-center px-4">
        <mat-icon class="text-5xl text-red-500 mb-4">error_outline</mat-icon>
        <h3 class="text-xl font-bold mb-2">Error Loading Packages</h3>
        <p class="text-gray-600 mb-4">We couldn't load the packages at this time. Please try again later.</p>
        <button class="bg-primary-500 text-white px-4 py-2 rounded hover:bg-primary-600 transition"
            (click)="ngOnInit()">
            Retry
        </button>
    </div>
    }
    @else {

    <div class="relative mt-10 flex items-center justify-between">
        <h1
            class="absolute left-1/2 transform -translate-x-1/2 text-3xl md:text-4xl font-extrabold text-gray-800 tracking-wide leading-snug">
            Popular Destinations
        </h1>

        <div class="ml-auto px-3">
            <button
                class="text-sm px-3 py-1 rounded border border-primary-500 hover:bg-accent-600 hover:border-accent-600"
                (click)="resetDestinationFilter()" *ngIf="view.selectedRegion !== 'All Destinations'">
                Reset Filter
            </button>
        </div>
    </div>

    <div class="px-10 pt-6 m-auto items-center text-center ">
        <div class="inline-flex items-center text-center p-2 cursor-pointer rounded-lg hover:bg-accent-500 hover:text-white mx-2 transition-all duration-300"
            *ngFor="let region of view.destinations" (click)="onRegionSelect(region.name)"
            [class.bg-primary-500]="view.selectedRegion === region.name"
            [class.text-white]="view.selectedRegion === region.name">
            <span class="mx-2">{{ region.name }}</span>
        </div>
    </div>

    @if (view.filteredBundles && view.filteredBundles.length > 0) {
    <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 px-4 md:px-8 lg:px-15 mt-15">
        @for(bundle of view.filteredBundles; track bundle) {
        @if (bundle.nights > 0) {
        <fuse-card class="flex flex-col w-full w-{350} mx-auto  overflow-hidden shadow-lg hover:shadow-xl ">
            <div class="relative">
                <img class="w-full h-60" [src]="bundle.imageUrls[0]" alt="Package Image">
                <div class="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-900/40"></div>
                <div class="absolute top-0 right-0 text-white px-8 py-5 text-xl tracking-wider custom_font">
                    {{bundle.supplier ? bundle.destinationName : bundle.destination}}</div>
                <div class="flex absolute top-0 right-0 justify-center items-center px-8 py-15">
                    @if(bundle.priceAccommodation) {
                    <div class="mr-3 text-white tracking-wider" [matTooltip]="'Accommodation'">
                        <mat-icon
                            class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                            [svgIcon]="'heroicons_outline:home-modern'"></mat-icon>
                    </div>
                    }
                    @if(bundle.priceFlights && !bundle.excludeFlights) {
                    <div class="mr-3 text-white tracking-wider" [matTooltip]="'Flights'">
                        <mat-icon
                            class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                            [svgIcon]="'mat_outline:airplanemode_active'"></mat-icon>
                    </div>
                    }
                    @if(bundle.priceCars) {
                    <div class="mr-3 text-white tracking-wider" [matTooltip]="'Car Rental'">
                        <mat-icon
                            class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                            [svgIcon]="'mat_outline:directions_car'"></mat-icon>
                    </div>
                    }
                    @if(bundle.priceTransfers) {
                    <div class="mr-3 text-white tracking-wider" [matTooltip]="'Transfers'">
                        <mat-icon
                            class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                            [svgIcon]="'mat_outline:airport_shuttle'"></mat-icon>
                    </div>
                    }
                    @if(bundle.priceCruises) {
                    <div class="mr-3 text-white tracking-wider" [matTooltip]="'Cruise'">
                        <mat-icon
                            class="icon-size-8 bg-primary-100 ring-2 ring-primary-500 rounded-full p-1 text-primary-500 hover:bg-primary-500 hover:text-primary-100 transition transition-duration: 500ms"
                            [svgIcon]="'mat_outline:directions_boat'"></mat-icon>
                    </div>
                    }
                </div>
            </div>
            <div class="flex flex-col justify-center bg-white dark:bg-slate-800 p-4">
                <div class="flex mb-2 h-4">
                    @if(bundle.supplier && bundle.supplier.grading > 0 && bundle.supplier.grading <= 1) { <mat-icon
                        class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                        }
                        @if(bundle.supplier && bundle.supplier.grading > 1 && bundle.supplier.grading <= 2) { <mat-icon
                            class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                            <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'"></mat-icon>
                            }
                            @if(bundle.supplier && bundle.supplier.grading > 2 && bundle.supplier.grading <= 3) {
                                <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'">
                                </mat-icon>
                                <mat-icon class="icon-size-5 text-yellow-500"
                                    [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                <mat-icon class="icon-size-5 text-yellow-500"
                                    [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                }
                                @if(bundle.supplier && bundle.supplier.grading > 3 && bundle.supplier.grading <= 4) {
                                    <mat-icon class="icon-size-5 text-yellow-500" [svgIcon]="'heroicons_solid:star'">
                                    </mat-icon>
                                    <mat-icon class="icon-size-5 text-yellow-500"
                                        [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    <mat-icon class="icon-size-5 text-yellow-500"
                                        [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    <mat-icon class="icon-size-5 text-yellow-500"
                                        [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                    }
                                    @if(bundle.supplier && bundle.supplier.grading > 4 && bundle.supplier.grading <= 5)
                                        { <mat-icon class="icon-size-5 text-yellow-500"
                                        [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500"
                                            [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500"
                                            [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500"
                                            [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        <mat-icon class="icon-size-5 text-yellow-500"
                                            [svgIcon]="'heroicons_solid:star'"></mat-icon>
                                        }
                </div>
                <p class="text-2xl custom_font font-semibold mb-2 h-14">{{bundle.supplier ? bundle.supplier.name :
                    bundle.name}}</p>
                <div class="flex gap-2 py-2">
                    @if (bundle.tagsArray) {
                    <div class="flex flex-wrap gap-2">
                        @for (tag of bundle.tagsArray; track $index) {
                        <span
                            class="justify-center items-center bg-accent-500 text-white text-sm rounded-full py-1 px-3 inline-block w-fit">
                            {{ tag }}
                        </span>
                        }
                    </div>
                    }
                    @if(bundle.basis) {
                    <div class="flex flex-wrap gap-2">
                        <span
                            class="justify-center items-center bg-primary-500 text-white text-sm rounded-full py-1 px-3 inline-block w-fit">
                            {{ bundle.basis }}
                        </span>
                    </div>
                    }
                </div>

                <div class="flex items-center justify-between">
                    <div class="flex flex-col space-y-2">
                        <p class="text-gray-500">{{bundle.nights}} {{bundle.nights === 1 ? 'Night' :
                            'Nights'}}</p>
                        <p class="text-gray-500">From<span
                                class="text-primary-500 text-2xl font-semibold ml-2">{{bundle.priceBundleTotal |
                                currency:(displayCurrencyCode || bundle.currency):'symbol-narrow'}}</span><sup
                                class="text-gray-500 ml-1">pps</sup></p>
                    </div>
                    <a [routerLink]="['/package', bundle.id, bundle.slug ? bundle.slug : slugify(bundle.name)]"
                        type="button"
                        class="ring-2 ring-accent-500 rounded-lg text-sm md:text-md font-bold py-1 md:py-2 px-2 transition transition-duration: 500ms hover:bg-accent-500 hover:text-primary-100">View
                        More</a>
                </div>
            </div>
        </fuse-card>
        }
        }
        <!-- </div> -->
    </div>
    } @else {
    <div class="text-center text-gray-500 mt-8 ">
        <p class="text-center">No results found</p>
    </div>
    }

    }

    <!-- <app-destination-list-type01></app-destination-list-type01> -->
</section>